import { render } from "./DividerLine.vue?vue&type=template&id=844bab18"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DividerLine.vue"]])

export default __exports__